import { sendGoogleEvent } from '@html/_common/utils';

export default function initiateBottomBanner(eventCategory) {
  const elementGAEvent = 'Bottom banner - Click';
  $('.js-ao-tour-bottom-banner__cta-favourite').click(() => {
    sendGoogleEvent(eventCategory, elementGAEvent, 'Add to Wishlist');
  });
  $('.js-ao-tour-bottom-banner__cta-brochure').click(() => {
    sendGoogleEvent(eventCategory, elementGAEvent, 'Download Brochure');
  });
  $('.js-ao-tour-bottom-banner__cta-ask').click(() => {
    sendGoogleEvent(eventCategory, elementGAEvent, 'Ask a Travel Expert');
  });
}
